import { NO_DATA_PLACEHOLDER, TableCell } from '@occc-app/design-system';
import { Cpg, SubmissionGroupLocationFragment } from '@occc/graphql';

export const CpgAccountHeaderCells = ({ cpg }: { cpg: Cpg }) =>
  cpg === Cpg.Altria ? (
    <>
      <TableCell>Altria MAN</TableCell>
      <TableCell>Altria RCN</TableCell>
    </>
  ) : (
    <TableCell>RJR Account #</TableCell>
  );

export const CpgAccountDataCells = ({
  cpg,
  location,
}: {
  cpg: Cpg;
  location: SubmissionGroupLocationFragment;
}) =>
  cpg === Cpg.Altria ? (
    <>
      <TableCell>{location.altriaMan ?? NO_DATA_PLACEHOLDER}</TableCell>
      <TableCell>{location.altriaRcn ?? NO_DATA_PLACEHOLDER}</TableCell>
    </>
  ) : (
    <TableCell>{location.rjrAccountNumber ?? NO_DATA_PLACEHOLDER}</TableCell>
  );
